import { Component, OnInit } from '@angular/core';
import { ComponentModalConfig, ModalSize, FuiModal } from 'ngx-fomantic-ui';
import { IModalOptions } from '../../../alert-facade-service/models';

export interface IInputModalContext {
  name: string;
  title?: string;
  defaultValue?: any;
  placeHolder?: string; // undefined == use name, null == no placeholder
  type?: 'text' | 'number' | 'email' | 'password';
}

@Component({
  selector: 'app-input-pad-modal',
  templateUrl: './input-pad-modal.component.html',
  styleUrls: ['./input-pad-modal.component.scss']
})
export class InputPadModalComponent implements OnInit {
  get placeHolderText() {
    if (this.modal.context.placeHolder)
      return this.modal.context.placeHolder;
    else if (this.modal.context.placeHolder === null)
      return "";

    return this.modal.context.name;
  }

  value: any;

  constructor(public modal: FuiModal<IInputModalContext, any, void>) { }

  ngOnInit() {
    this.value = this.modal.context.defaultValue;
  }
}
export class InputPadModal<T> extends ComponentModalConfig<IInputModalContext, T, void> {
  constructor(context: IInputModalContext, options: IModalOptions = {}) {
      if (!context.type)
        context.type = 'text';
      super(InputPadModalComponent, context);

      this.isClosable = options.closable || false;
      this.transitionDuration = options.transitionDuration || 200;
      this.size = options.size || ModalSize.Tiny;
      this.isBasic = options.isBasic || false;
  }
}